module.exports = __webpack_public_path__ + "static/media/Casino-Days-Two-Lines-Gradient-BG-800x480.802d75d4.png";